import React, { useState, useEffect } from 'react';
import { Pressable, View } from 'react-native'

import tw from '../styles/tailwind';
import Text from '../components/Text';
import Icon from '../components/IcomoonIcon';


export default function IconButton({
  title,
  onPress,
  onLongPress=null,
  delayLongPress=500,
  color = "primary",
  icon = "add1", 
  iconPosition = "left", 
  iconSize=15,
  disabled=false,
  textColor = "white",
  style = {},
}) {
  return (
    <Pressable
      style={pressed => tw.style(`row px-4 py-2 rounded-full justify-center bg-${color}`, (disabled || pressed.pressed) && `opacity-50`, style)} 
      onPress={onPress}
      disabled={disabled}
      onLongPress={onLongPress}
      delayLongPress={delayLongPress}
    >
      {
        (iconPosition == 'left' && icon) &&
          <Icon name={icon} size={iconSize} color={tw.color(textColor)} style={tw`mr-3`} />
      }

      {
        title &&
          <Text style={tw.style(`text-${textColor} text-base`)}>{title}</Text>
      }

      {
        (iconPosition == 'right' && icon) &&
          <Icon name={icon} size={iconSize} color={tw.color(textColor)} style={tw`ml-3`} />
      }
    </Pressable>
  )
}